import styled from 'styled-components';

const SwitcherWrapper = styled.div`
  position: fixed;
  top: 16px;
  right: 18px;
  z-index: 120;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.55rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(148, 163, 184, 0.6);
`;

const Label = styled.span`
  font-size: 0.65rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(226, 232, 240, 0.9);
`;

const PillGroup = styled.div`
  display: inline-flex;
  gap: 0.25rem;
`;

const Pill = styled.button`
  cursor: pointer;
  border-radius: 999px;
  border: none;
  padding: 0.25rem 0.7rem;
  font-size: 0.65rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: ${({ active }) =>
    active ? 'var(--accent)' : 'rgba(15, 23, 42, 0.8)'};
  color: ${({ active }) => (active ? '#020617' : 'rgba(226,232,240,0.9)')};
  box-shadow: ${({ active }) =>
    active ? '0 0 18px var(--accent-soft)' : 'none'};
  transition: all 0.24s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.9;
  }
`;

const ThemeSwitcher = ({ value, onChange }) => {
  const setTheme = (name) => () => {
    if (value !== name) onChange?.(name);
  };

  return (
    <SwitcherWrapper>
      <Label>Theme</Label>
      <PillGroup>
        <Pill active={value === 'dark'} onClick={setTheme('dark')}>
          Dark
        </Pill>
        <Pill active={value === 'light'} onClick={setTheme('light')}>
          Light
        </Pill>
        <Pill active={value === 'blueRed'} onClick={setTheme('blueRed')}>
          Blue/Red
        </Pill>
      </PillGroup>
    </SwitcherWrapper>
  );
};

export default ThemeSwitcher;
